module.exports = __webpack_public_path__ + "img/about_banner.8b59325d.png";